import { render, staticRenderFns } from "./thirdCard.vue?vue&type=template&id=e1a3ad34&scoped=true&"
import script from "./thirdCard.vue?vue&type=script&lang=js&"
export * from "./thirdCard.vue?vue&type=script&lang=js&"
import style0 from "./thirdCard.vue?vue&type=style&index=0&id=e1a3ad34&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1a3ad34",
  null
  
)

export default component.exports